/** Menu fixed calé dans le viewport visible, y compris sur un téléphone. */
export type MenuPlace = { top: number; left: number; maxHeight: number };

export function placeFixedMenu(anchor: DOMRect, width: number, height: number): MenuPlace {
  const margin = 8;
  const gap = 6;
  const vv = window.visualViewport;
  const viewTop = vv?.offsetTop ?? 0;
  const viewLeft = vv?.offsetLeft ?? 0;
  const viewH = vv?.height ?? window.innerHeight;
  const viewW = vv?.width ?? window.innerWidth;
  const limitTop = viewTop + margin;
  const limitBottom = viewTop + viewH - margin;
  const limitLeft = viewLeft + margin;
  const limitRight = viewLeft + viewW - margin;
  const spaceBelow = Math.max(0, limitBottom - anchor.bottom - gap);
  const spaceAbove = Math.max(0, anchor.top - limitTop - gap);
  const want = Math.max(height, 48);
  const openUp = spaceBelow < want && spaceAbove > spaceBelow;
  const room = Math.max(96, openUp ? spaceAbove : spaceBelow);
  const h = Math.min(want, room);
  let top = openUp ? anchor.top - gap - h : anchor.bottom + gap;
  if (top < limitTop) top = limitTop;
  if (top + h > limitBottom) top = Math.max(limitTop, limitBottom - h);
  const maxHeight = Math.max(96, limitBottom - top);
  let left = anchor.right - width;
  if (left < limitLeft) left = limitLeft;
  if (left + width > limitRight) left = Math.max(limitLeft, limitRight - width);
  return { top, left, maxHeight };
}

export function watchMenuPlace(place: () => void): () => void {
  place();
  const raf = window.requestAnimationFrame(place);
  window.addEventListener("resize", place);
  document.addEventListener("scroll", place, true);
  window.visualViewport?.addEventListener("resize", place);
  window.visualViewport?.addEventListener("scroll", place);
  return () => {
    window.cancelAnimationFrame(raf);
    window.removeEventListener("resize", place);
    document.removeEventListener("scroll", place, true);
    window.visualViewport?.removeEventListener("resize", place);
    window.visualViewport?.removeEventListener("scroll", place);
  };
}
